var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
// Vue 2 + vue-loader v15 in this recovered app does not transform defineOptions.
// Provide a no-op global shim so script-setup components using it won't crash at runtime.
if (typeof window !== 'undefined' && typeof window.defineOptions !== 'function') {
    window.defineOptions = function () { };
}
// Styles
import 'bootstrap';
import 'vue-toastification/dist/index.css';
import 'vue-select/dist/vue-select.css';
// Plugins
Vue.use(BootstrapVue);
Vue.config.ignoredElements = __spreadArray(__spreadArray([], (Vue.config.ignoredElements || []), true), [/^md-/], false);
Vue.filter('date', function (value) {
    if (!value) {
        return '';
    }
    var date = value instanceof Date ? value : new Date(String(value));
    if (Number.isNaN(date.getTime())) {
        return String(value);
    }
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
});
var bootstrapVueApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, router, AppShellRoot, vueAppElement, app;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, import('@/plugins/veeValidate')];
            case 1:
                _b.sent();
                return [4 /*yield*/, import('@/plugins/fontawesome')];
            case 2:
                _b.sent();
                return [4 /*yield*/, import('@/plugins/vueTippy')];
            case 3:
                _b.sent();
                return [4 /*yield*/, import('@/plugins/vueToastification')];
            case 4:
                _b.sent();
                return [4 /*yield*/, Promise.all([
                        import('@/router'),
                        import('@/components/AppShell/AppShellRoot.vue')
                    ])];
            case 5:
                _a = _b.sent(), router = _a[0].default, AppShellRoot = _a[1].default;
                vueAppElement = document.getElementById('app');
                if (vueAppElement && !vueAppElement.__customilyVueRootMounted) {
                    vueAppElement.__customilyVueRootMounted = true;
                    app = new Vue({
                        router: router,
                        render: function (createElement) { return createElement(AppShellRoot); }
                    }).$mount();
                    vueAppElement.appendChild(app.$el);
                }
                return [2 /*return*/];
        }
    });
}); };
bootstrapVueApp().catch(function (error) {
    var _a;
    (_a = window.rumReportError) === null || _a === void 0 ? void 0 : _a.call(window, error);
    console.error(error);
});
